import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteProps } from "primereact/autocomplete"
import { classNames } from "primereact/utils"
import { useState } from "react"

export type HUAutoCompleteInputProps = AutoCompleteProps

export const HUAutoCompleteInput: React.FC<HUAutoCompleteInputProps> = ({ value, ...props }) => {
  const [inputValue, setInputValue] = useState<string>(value || "")
  const [suggestions, setSuggestions] = useState<string[]>(props.suggestions || [])

  const search = (event: AutoCompleteCompleteEvent) => {
    setSuggestions(props.suggestions?.filter((item) => item.toLowerCase().includes(event.query.toLowerCase())) || [])
  }

  return (
    <AutoComplete
      dropdown
      className={classNames({ "p-invalid": props.invalid })}
      {...props}
      value={inputValue}
      onChange={(e) => {
        setInputValue(e.target.value)
      }}
      suggestions={suggestions}
      completeMethod={search}
    />
  )
}
